/**
 * 随访问卷模板模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

/* 随访问卷模板 */
// 获取随访问卷模板列表
export const templateList = (params) => {
  return req.get('/exam/template/list', params);
}

// 新增随访问卷模板
export const templateAdd = (params) => {
  return req.post('/exam/template', params);
}

// 修改随访问卷模板
export const templateEdit = (params) => {
  return req.put('/exam/template', params);
}

// 删除随访问卷模板
export const templateDelete = (examTemplateIds) => {
  return req.delete(`/exam/template/${examTemplateIds}`);
}

/* 随访问卷题目 */
// 获取随访问卷题目列表
export const questionList = (params) => {
  return req.get('/exam/template/questions/list', params);
}

// 新增随访问卷题目
export const questionAdd = (params) => {
  return req.post('/exam/template/questions', params);
}

// 修改随访问卷题目
export const questionEdit = (params) => {
  return req.put('/exam/template/questions', params);
}

// 删除随访问卷题目
export const questionDelete = (examTemplateQuestionsId) => {
  return req.delete(`/exam/template/questions/${examTemplateQuestionsId}`);
}

// 查询随访问卷题目详情
export const questionInfo = (examTemplateQuestionsId) => {
  return req.get(`/exam/template/questions/${examTemplateQuestionsId}`);
}


/* 随访问卷题库 */
// 获取随访题库列表
export const questionBankList = (params) => {
  return req.get('/exam/question/bank/list', params);
}

// 获取随访题库详情
export const questionBankDetails = (examQuestionBankId) => {
  return req.get(`/exam/question/bank/${examQuestionBankId}`);
}

// 新增随访题库
export const questionBankAdd = (params) => {
  return req.post('/exam/question/bank', params);
}

// 修改随访题库
export const questionBankEdit = (params) => {
  return req.put('/exam/question/bank', params);
}

// 删除随访题库
export const questionBankDelete = (examQuestionBankId) => {
  return req.delete(`/exam/question/bank/${examQuestionBankId}`);
}

/* 日常随访提示 */
// 获取随访提示列表
export const hintBankList = (params) => {
  return req.get('/exam/hint/template/list', params);
}

// 新增随访提示
export const hintBankAdd = (params) => {
  return req.post('/exam/hint/template', params);
}

// 修改随访提示
export const hintBankEdit = (params) => {
  return req.put('/exam/hint/template', params);
}

// 删除随访提示
export const hintBankDelete = (examHintMessageTemplates) => {
  return req.delete(`/exam/hint/template/${examHintMessageTemplates}`);
}